/** Global English Google Ads averages, fetched 2026-10-16 through DataForSEO.
 * Null/unmeasured entries are not zero demand. Keep research metadata internal. */
export const alternativesSearchDemand: Readonly<Record<string, number>> = {
  playwright: 1300,
  firecrawl: 1000,
  apify: 880,
  selenium: 880,
  serpapi: 590,
  puppeteer: 390,
  dataforseo: 210,
  zenrows: 70,
}

export function sortAlternativesByDemand<T extends { sourceSlug: string; sourceName: string }>(
  pages: readonly T[],
): T[] {
  return [...pages].sort(
    (a, b) =>
      (alternativesSearchDemand[b.sourceSlug] ?? -1) -
        (alternativesSearchDemand[a.sourceSlug] ?? -1) ||
      a.sourceName.localeCompare(b.sourceName) ||
      a.sourceSlug.localeCompare(b.sourceSlug),
  )
}
